<template>
    <div class="kt-portlet__head">
        <form class="isprint-filter" autocomplete="off"> 
            <div class="form-group">
                <label>APPEZZAMENTO</label>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Appezzamento" type="text" style="width:160px" v-model="search.ID_APPEZZAMENTO.VALUE">
            </div>
            <div class="form-group">
                <label>FOGLIO</label>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Foglio" type="text" style="width:120px" v-model="search.FOGLIO.VALUE">
            </div>
            <div class="form-group ">
                <label>PARTICELLA</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Particella" type="text" style="width:130px" v-model="search.PARTICELLA.VALUE">
            </div>
            <div class="form-group ">
                <label>LOCALITA</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Località" type="text" style="width:160px" v-model="search.LOCALITA.VALUE">
            </div>
            <div class="form-group ">
                <label>TIPOLOGIA</label><br>
                <select class="form-control form-control-sm" style="width:170px" v-model="search.FK_ID_TIPO.VALUE">
                    <option value="">Tutte</option>
                    <option v-for="tipo in arrayTipiTerreno" :key="tipo.ID_TIPO" :value="tipo.ID_TIPO">{{ tipo.DESCRIZIONE }}</option>
                </select>
            </div>
            <div class="form-group">
                <label>STATO ASSEGNAZIONE</label><br>
                <select class="form-control form-control-sm" style="width:170px" v-model="search.IS_ASSEGNATO.VALUE">
                    <option value="">Tutti i terreni</option>
                    <option value="0">Solo non assegnati</option>
                    <option value="1">Solo assegnati</option>
                </select>
            </div>
            <div class="form-group ">
                <label>COGNOME ASSEGNATARIO</label><br>
                <input class="form-control form-control-sm" :disabled="search.IS_ASSEGNATO.VALUE === '0'" autocomplete="off" name="adasd" placeholder="Cognome" type="text" style="width:160px" v-model="search.COGNOME.VALUE">
            </div>
            <div class="form-group ">
                <label>NOME ASSEGNATARIO</label><br>
                <input class="form-control form-control-sm" :disabled="search.IS_ASSEGNATO.VALUE === '0'" autocomplete="off" name="adasd" placeholder="Nome" type="text" style="width:160px" v-model="search.NOME.VALUE">
            </div>
            <div class="float-right my-2 my-sm-3 mt-4">
                <button type="button" class="btn btn-dark btn-sm mr-2" v-on:click="apriStampeRuoli()"><i class="fas fa-print"></i> Stampe e Ruoli</button>
                <button type="button" class="btn btn-success btn-sm mr-2" v-on:click="creaTerreno()"><i class="fas fa-plus"></i> Nuovo Terreno</button>
                <button type="button" class="btn btn-primary btn-sm" v-on:click="apriGestioneTipologie()"><i class="fas fa-tags"></i> Gestione tipologie</button>
            </div>
        </form> 
    </div>
    <div class="isprint-grid-container"  >    
        <table class="isprint-grid shadow" >
            <thead class="isprint-grid-thead" >
                <tr style="left: 0px;background: #258c08;color:#fff">
                    <th  style="width:10%"><span >ID APPEZZAMENTO</span></th>
                    <th  style="width:5%"><span >FOGLIO</span></th>
                    <th  style="width:5%"><span >PARTICELLA</span></th>
                    <th  style="width:20%"><span >LOCALITA</span></th>
                    <th  style="width:18%"><span >TIPOLOGIA</span></th>
                    <th  style="width:22%"><span >ASSEGNATARIO</span></th>
                    <th  style="width:10%"><span >AZIONI</span></th>
                    
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-bind:key="terreno.ID_TERRENO"  v-for="terreno in paginatedList.arr">                        
                    <td  style="width:10%;font-size:16px">
                        {{ terreno.ID_APPEZZAMENTO }}
                    </td>
                    <td  style="width:5%">
                        {{ terreno.FOGLIO }}
                    </td>
                    <td  style="width:5%">
                        {{ terreno.PARTICELLA }}
                    </td>         
                    <td  style="width:20%">
                        {{ terreno.LOCALITA }}
                    </td>
                    <td  style="width:18%">
                        <span class="badge badge-info text-wrap" style="font-size:12px;padding:4px 8px;font-weight:600;white-space:normal;text-align:left;display:inline-block;">
                            {{ terreno.TIPO_TERRENO || getNomeTipo(terreno.FK_ID_TIPO) }}
                        </span>
                    </td>
                    <td  style="width:22%">
                        <div v-if="terreno.COGNOME">
                            {{ terreno.COGNOME }} {{ terreno.NOME }}
                            <br>
                            <small>{{ terreno.DATA_NASCITA }} - {{ terreno.CODICE_FISCALE }}</small>
                        </div>
                        <div v-else>
                            <span class="badge badge-secondary" style="font-size:11px;padding:3px 8px;font-weight:500;">
                                <i class="fal fa-user-slash mr-1"></i> Non assegnato
                            </span>
                        </div>
                    </td>
                    <td  style="width:10%">
                        <div class="btn-group float-right" role="group" aria-label="Azioni">
                            <button v-if="terreno.COGNOME" data-toggle="tooltip" data-placement="top" title="Certificato di Assegnazione" class="btn btn-info btn-sm mr-1" v-on:click="stampaCertificato(terreno.ID_TERRENO)"><i class="fal fa-file-certificate"></i></button>
                            <button v-if="terreno.COGNOME" data-toggle="tooltip" data-placement="top" title="Avviso di Pagamento" class="btn btn-success btn-sm mr-1" v-on:click="stampaAvviso(terreno.ID_TERRENO)"><i class="fal fa-file-invoice-dollar"></i></button>
                            <button data-toggle="tooltip" data-placement="top" title="Modifica terreno" class="btn btn-warning btn-sm float-right" v-on:click="modificaTerreno(terreno.ID_TERRENO)"><i class="fal fa-pencil"></i></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER"  :numrighe="paginatedList.count"  :numpagine="search.PAGINATION.LENGTH"></Pagine> 
    </div>
    <div class="modal fade" id="popUpTerreno" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:1000px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header" style="background-color: #226636;">
                    <h4 style="color:#fff" class="modal-title">{{ terrenoSelezionato.LOCALITA }}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" >
                    <Terreno  v-model="terrenoSelezionato" @ricarica="modificaTerreno($event)" @getTerreno=" getTerreno" ref="terreno"></Terreno>       
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaTerreno()"><i class="fa fa-check"></i> Salva</button>
                </div>
            </div>  
        </div>
    </div>

    <!-- Modale Gestione Tipologie Terreno -->
    <div class="modal fade" id="popUpGestioneTipologie" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg" style="min-width:900px;">
            <div class="modal-content">
                <div class="modal-header" style="background-color: #226636;">
                    <h4 style="color:#fff" class="modal-title"><i class="fas fa-tags"></i> Gestione Tipologie Terreno</h4>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!-- Sotto-form di inserimento/modifica tipologia -->
                    <div v-if="mostraFormTipo" class="card mb-3 p-3 bg-light border">
                        <h5 class="mb-3">
                            <i class="fal fa-pencil" v-if="tipoInModifica.ID_TIPO > 0"></i>
                            <i class="fal fa-plus" v-else></i>
                            {{ tipoInModifica.ID_TIPO > 0 ? 'Modifica Tipologia #' + tipoInModifica.ID_TIPO : 'Nuova Tipologia' }}
                        </h5>
                        <div class="row">
                            <div class="form-group col-md-5">
                                <label><strong>Descrizione *</strong></label>
                                <input type="text" class="form-control form-control-sm" placeholder="Descrizione tipologia" v-model="tipoInModifica.DESCRIZIONE">
                            </div>
                            <div class="form-group col-md-2">
                                <label><strong>Tipo</strong></label>
                                <select class="form-control form-control-sm" v-model="tipoInModifica.TIPO">
                                    <option value="1">1 (Ordinario)</option>
                                    <option value="2">2 (Secondario)</option>
                                </select>
                            </div>
                            <div class="form-group col-md-2">
                                <label><strong>Modalità</strong></label>
                                <select class="form-control form-control-sm" v-model="tipoInModifica.MODO">
                                    <option value="F">F (Fisso)</option>
                                    <option value="P">P (Proporzionale)</option>
                                </select>
                            </div>
                            <div class="form-group col-md-3">
                                <label><strong>Tariffa Predefinita (€)</strong></label>
                                <input type="number" step="0.01" class="form-control form-control-sm" placeholder="es. 125.00" v-model="tipoInModifica.TARIFFA">
                            </div>
                            <div class="form-group col-md-4">
                                <label><strong>Gruppo Padre</strong></label>
                                <select class="form-control form-control-sm" v-model="tipoInModifica.GRUPPO">
                                    <option value="0">- Nessuno -</option>
                                    <option v-for="t in arrayTipiTerrenoPadri" :key="t.ID_TIPO" :value="t.ID_TIPO">{{ t.DESCRIZIONE }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-8 pt-2" v-if="tipoInModifica.ID_TIPO > 0">
                                <div class="form-check mt-3">
                                    <input class="form-check-input" type="checkbox" id="checkRicalcolaCanoni" v-model="tipoInModifica.RICALCOLA_TERRENI">
                                    <label class="form-check-label" for="checkRicalcolaCanoni" style="font-size:13px;">
                                        <strong>Applica a tutti i terreni di questo tipo</strong> (ricalcola Canone Unitario e Canone Totale)
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="text-right mt-2">
                            <button type="button" class="btn btn-secondary btn-sm mr-2" v-on:click="mostraFormTipo = false">Annulla</button>
                            <button type="button" class="btn btn-success btn-sm" v-on:click="salvaTipoTerreno()"><i class="fa fa-check"></i> Salva Tipologia</button>
                        </div>
                    </div>

                    <!-- Header elenco -->
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <strong>Tipologie configurate:</strong> {{ arrayTipiTerreno.length }}
                        </div>
                        <button v-if="!mostraFormTipo" type="button" class="btn btn-success btn-sm" v-on:click="creaNuovoTipoTerreno()">
                            <i class="fas fa-plus"></i> Nuova Tipologia
                        </button>
                    </div>

                    <!-- Tabella elenco tipologie -->
                    <div class="table-responsive" style="max-height: 420px; overflow-y: auto;">
                        <table class="table table-bordered table-hover table-striped mb-0">
                            <thead class="thead-dark">
                                <tr>
                                    <th style="width:6%">ID</th>
                                    <th style="width:34%">Descrizione</th>
                                    <th style="width:8%">Tipo</th>
                                    <th style="width:12%">Modalità</th>
                                    <th style="width:14%">Tariffa (€)</th>
                                    <th style="width:12%">Gruppo</th>
                                    <th style="width:14%">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="tipo in arrayTipiTerreno" :key="tipo.ID_TIPO">
                                    <td><strong>{{ tipo.ID_TIPO }}</strong></td>
                                    <td>{{ tipo.DESCRIZIONE }}</td>
                                    <td><span class="badge badge-secondary">{{ tipo.TIPO }}</span></td>
                                    <td>
                                        <span class="badge" :class="tipo.MODO == 'F' ? 'badge-primary' : 'badge-warning'">
                                            {{ tipo.MODO == 'F' ? 'F (Fisso)' : (tipo.MODO == 'P' ? 'P (Prop.)' : tipo.MODO) }}
                                        </span>
                                    </td>
                                    <td>
                                        <strong style="color: #226636;">€ {{ parseFloat(tipo.TARIFFA || 0).toFixed(2) }}</strong>
                                    </td>
                                    <td>{{ getNomeGruppo(tipo.GRUPPO) }}</td>
                                    <td>
                                        <div class="btn-group btn-group-sm" role="group">
                                            <button type="button" class="btn btn-warning btn-sm" title="Modifica tipologia" v-on:click="modificaTipoTerreno(tipo)">
                                                <i class="fal fa-pencil"></i>
                                            </button>
                                            <button type="button" class="btn btn-info btn-sm" title="Applica tariffa a tutti i terreni di questo tipo" v-on:click="applicaTariffaATutti(tipo)">
                                                <i class="fal fa-calculator"></i>
                                            </button>
                                            <button type="button" class="btn btn-danger btn-sm" title="Elimina tipologia" v-on:click="eliminaTipoTerreno(tipo)">
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modale Stampe e Ruoli -->
    <div class="modal fade" id="popUpStampeRuoli" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg" style="min-width:850px;">
            <div class="modal-content">
                <div class="modal-header" style="background-color: #1a365d; color: #fff;">
                    <h4 class="modal-title text-white"><i class="fas fa-print mr-2"></i> Stampe e Ruoli Terreni</h4>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ul class="nav nav-tabs mb-4" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: tabStampe == 'avvisi' }" href="#" @click.prevent="tabStampe = 'avvisi'">
                                <i class="fal fa-file-invoice-dollar mr-1"></i> Avvisi di Pagamento / Bollettini
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: tabStampe == 'certificati' }" href="#" @click.prevent="tabStampe = 'certificati'">
                                <i class="fal fa-file-certificate mr-1"></i> Certificati di Assegnazione
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: tabStampe == 'ruolo' }" href="#" @click.prevent="tabStampe = 'ruolo'">
                                <i class="fal fa-table mr-1"></i> Ruolo Generale Canoni
                            </a>
                        </li>
                    </ul>

                    <!-- Tab Avvisi di Pagamento -->
                    <div v-if="tabStampe == 'avvisi'">
                        <div class="alert alert-light border">
                            Generazione degli <strong>avvisi di pagamento</strong> e dei bollettini PagoPA per gli assegnatari attivi di terreni.<br/>
                            <small class="text-muted"><i class="fas fa-database text-info mr-1"></i> I bollettini generati vengono salvati e congelati come snapshot nel database per il tracciamento dei pagamenti (Stato: Generato, Inviato, Pagato).</small>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label><strong>Anno di Carico</strong></label>
                                <input type="number" class="form-control form-control-sm" v-model="formStampe.anno">
                            </div>
                            <div class="form-group col-md-4">
                                <label><strong>Numero Rate</strong></label>
                                <select class="form-control form-control-sm" v-model="formStampe.numeroRate">
                                    <option value="2">2 Rate (Luglio / Agosto)</option>
                                    <option value="3">3 Rate (Luglio / Settembre / Novembre)</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label><strong>Spese di Notifica (€)</strong></label>
                                <input type="number" step="0.01" class="form-control form-control-sm" placeholder="0.00" v-model="formStampe.speseNotifica">
                            </div>
                            <div class="form-group col-md-6">
                                <label><strong>Filtro Iniziale Cognome</strong></label>
                                <select class="form-control form-control-sm" v-model="formStampe.lettera">
                                    <option value="+">- Tutti gli assegnatari -</option>
                                    <option v-for="l in lettereAlfabeto" :key="l" :value="l">{{ l }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label><strong>Nome Presidente Firmatario</strong></label>
                                <input type="text" class="form-control form-control-sm" v-model="formStampe.presidente">
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center mt-3">
                            <button type="button" class="btn btn-outline-primary" v-on:click="apriPagamentiRuoli()">
                                <i class="fad fa-file-invoice-dollar mr-1"></i> Gestione Pagamento Ruoli
                            </button>
                            <button type="button" class="btn btn-success" v-on:click="lanciaStampaAvvisi()">
                                <i class="fal fa-file-pdf mr-1"></i> Genera Bollettini ed Avvisi PDF
                            </button>
                        </div>
                    </div>

                    <!-- Tab Certificati di Assegnazione -->
                    <div v-if="tabStampe == 'certificati'">
                        <div class="alert alert-light border">
                            Stampa dei <strong>certificati di concessione</strong> per tutti gli assegnatari o filtrati per iniziale cognome.
                        </div>
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label><strong>Stagione Agraria</strong></label>
                                <input type="text" class="form-control form-control-sm" placeholder="es. 2025/2026" v-model="formStampe.stagione">
                            </div>
                            <div class="form-group col-md-4">
                                <label><strong>Valido Dal</strong></label>
                                <input type="text" class="form-control form-control-sm" placeholder="01/11/2025" v-model="formStampe.dataDa">
                            </div>
                            <div class="form-group col-md-4">
                                <label><strong>Valido Al</strong></label>
                                <input type="text" class="form-control form-control-sm" placeholder="31/10/2026" v-model="formStampe.dataA">
                            </div>
                            <div class="form-group col-md-6">
                                <label><strong>Filtro Iniziale Cognome</strong></label>
                                <select class="form-control form-control-sm" v-model="formStampe.lettera">
                                    <option value="+">- Tutti gli assegnatari -</option>
                                    <option v-for="l in lettereAlfabeto" :key="l" :value="l">{{ l }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label><strong>Nome Presidente Firmatario</strong></label>
                                <input type="text" class="form-control form-control-sm" v-model="formStampe.presidente">
                            </div>
                        </div>
                        <div class="text-right mt-3">
                            <button type="button" class="btn btn-info" v-on:click="lanciaStampaCertificati()">
                                <i class="fal fa-file-pdf mr-1"></i> Genera Certificati PDF
                            </button>
                        </div>
                    </div>

                    <!-- Tab Ruolo Generale Canoni -->
                    <div v-if="tabStampe == 'ruolo'">
                        <div class="alert alert-light border">
                            Stampa del <strong>tabulato riepilogativo</strong> del Ruolo dei Canoni Terratici con totale importi e ripartizione in rate.
                        </div>
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label><strong>Anno Ruolo</strong></label>
                                <input type="number" class="form-control form-control-sm" v-model="formStampe.anno">
                            </div>
                            <div class="form-group col-md-4">
                                <label><strong>Numero Rate</strong></label>
                                <select class="form-control form-control-sm" v-model="formStampe.numeroRate">
                                    <option value="2">2 Rate</option>
                                    <option value="3">3 Rate</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label><strong>Filtro Lettera</strong></label>
                                <select class="form-control form-control-sm" v-model="formStampe.lettera">
                                    <option value="+">- Tutti gli assegnatari -</option>
                                    <option v-for="l in lettereAlfabeto" :key="l" :value="l">{{ l }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-12">
                                <label><strong>Nome Presidente Firmatario</strong></label>
                                <input type="text" class="form-control form-control-sm" v-model="formStampe.presidente">
                            </div>
                        </div>
                        <div class="text-right mt-3">
                            <button type="button" class="btn btn-primary" v-on:click="lanciaStampaRuolo()">
                                <i class="fal fa-file-pdf mr-1"></i> Genera Tabulato Ruolo PDF
                            </button>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>


import Pagine from '@/components/utils/Pagine.vue'
import Terreno from '@/components/Terreno.vue'



export default {
    name:"Terreni",
    components:{
        Pagine,
        Terreno
    },
    data:function(){
        return{
            filters:global.filters,
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:50},
                ID_APPEZZAMENTO:{TYPE:'TEXT',VALUE:''}, 
                FOGLIO:{TYPE:'TEXT',VALUE:''}, 
                PARTICELLA:{TYPE:'TEXT',VALUE:''}, 
                LOCALITA:{TYPE:'TEXT',VALUE:''},
                FK_ID_TIPO:{TYPE:'COMBO',VALUE:''},
                IS_ASSEGNATO:{TYPE:'COMBO',VALUE:''},
                COGNOME:{TYPE:'TEXT',VALUE:''},
                NOME:{TYPE:'TEXT',VALUE:''},
                               
            },        
        
            arrayTerreni:new Array(),
            arrayTipiTerreno:new Array(),
            anni:new Array(),
            terrenoSelezionato: {},
            mostraFormTipo: false,
            tipoInModifica: {},
            tabStampe: 'avvisi',
            lettereAlfabeto: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
            formStampe: {
                anno: new Date().getFullYear(),
                numeroRate: 2,
                speseNotifica: 0.00,
                lettera: '+',
                presidente: 'Il Presidente',
                stagione: (new Date().getFullYear() - 1) + '/' + new Date().getFullYear(),
                dataDa: '01/11/' + (new Date().getFullYear() - 1),
                dataA: '31/10/' + new Date().getFullYear()
            },
        
        }
    },
    methods: {
        getTerreni : function(){
            global.utils.get('/emmet/terreni',{}, (response) => {       
                this.arrayTerreni = (response.data || []).map(t => {
                    t.IS_ASSEGNATO = (t.ID_PERSONA_FISICA && parseInt(t.ID_PERSONA_FISICA) > 0) ? 1 : 0;
                    return t;
                });
            });
        },
        apriStampeRuoli: function(){
            var currYear = new Date().getFullYear();
            this.formStampe.anno = currYear;
            this.formStampe.stagione = (currYear - 1) + '/' + currYear;
            this.formStampe.dataDa = '01/11/' + (currYear - 1);
            this.formStampe.dataA = '31/10/' + currYear;
            $('#popUpStampeRuoli').modal('show');
        },
        stampaCertificato: function(idTerreno){
            var url = global.utils.BASE_API + "core/report?ID_REPORT=1003&ID_TERRENO=" + idTerreno + "&SESSION_TOKEN=" + utils.SESSION_TOKEN;
            window.open(url);
        },
        stampaAvviso: function(idTerreno){
            var url = global.utils.BASE_API + "core/report?ID_REPORT=1004&ID_TERRENO=" + idTerreno + "&SESSION_TOKEN=" + utils.SESSION_TOKEN;
            window.open(url);
        },
        apriPagamentiRuoli: function(){
            utils.closeModal('popUpStampeRuoli');
            global.router.push('/PagamentiRuoli');
        },
        lanciaStampaAvvisi: function(){
            global.utils.post('/emmet/bollettini/genera', {
                ANNO: this.formStampe.anno,
                NUMERO_RATE: this.formStampe.numeroRate,
                SPESE_NOTIFICA: this.formStampe.speseNotifica,
                LETTERA: this.formStampe.lettera,
                PRESIDENTE: this.formStampe.presidente
            }, (response) => {
                if (response && response.esito == 0) {
                    utils.notifySuccess("Bollettini sincronizzati su DB (" + response.generati + " generati, " + response.aggiornati + " aggiornati).");
                }
            });
            var url = global.utils.BASE_API + "core/report?ID_REPORT=1004"
                + "&ANNO=" + encodeURIComponent(this.formStampe.anno)
                + "&NUMERO_RATE=" + encodeURIComponent(this.formStampe.numeroRate)
                + "&SPESE_NOTIFICA=" + encodeURIComponent(this.formStampe.speseNotifica)
                + "&LETTERA=" + encodeURIComponent(this.formStampe.lettera)
                + "&PRESIDENTE=" + encodeURIComponent(this.formStampe.presidente)
                + "&SESSION_TOKEN=" + utils.SESSION_TOKEN;
            window.open(url);
        },
        lanciaStampaCertificati: function(){
            var url = global.utils.BASE_API + "core/report?ID_REPORT=1003"
                + "&STAGIONE=" + encodeURIComponent(this.formStampe.stagione)
                + "&DATA_DA=" + encodeURIComponent(this.formStampe.dataDa)
                + "&DATA_A=" + encodeURIComponent(this.formStampe.dataA)
                + "&LETTERA=" + encodeURIComponent(this.formStampe.lettera)
                + "&PRESIDENTE=" + encodeURIComponent(this.formStampe.presidente)
                + "&SESSION_TOKEN=" + utils.SESSION_TOKEN;
            window.open(url);
        },
        lanciaStampaRuolo: function(){
            var url = global.utils.BASE_API + "core/report?ID_REPORT=1005"
                + "&ANNO=" + encodeURIComponent(this.formStampe.anno)
                + "&NUMERO_RATE=" + encodeURIComponent(this.formStampe.numeroRate)
                + "&LETTERA=" + encodeURIComponent(this.formStampe.lettera)
                + "&PRESIDENTE=" + encodeURIComponent(this.formStampe.presidente)
                + "&SESSION_TOKEN=" + utils.SESSION_TOKEN;
            window.open(url);
        },
        getTipiTerreno : function(){
            global.utils.get('/emmet/tipi_terreno',{}, (response) => {       
                this.arrayTipiTerreno = response.data || [];
            });
        },
        getNomeTipo : function(idTipo){
            if (!idTipo) return '';
            var trovato = this.arrayTipiTerreno.find(t => t.ID_TIPO == idTipo);
            return trovato ? trovato.DESCRIZIONE : '';
        },
        getNomeGruppo : function(idGruppo){
            if (!idGruppo || idGruppo == 0) return ' - ';
            var trovato = this.arrayTipiTerreno.find(t => t.ID_TIPO == idGruppo);
            return trovato ? trovato.DESCRIZIONE : '#' + idGruppo;
        },
        apriGestioneTipologie : function(){
            this.mostraFormTipo = false;
            this.getTipiTerreno();
            utils.openModal('popUpGestioneTipologie');
        },
        creaNuovoTipoTerreno : function(){
            this.tipoInModifica = {
                ID_TIPO: 0,
                DESCRIZIONE: '',
                TIPO: 1,
                MODO: 'F',
                TARIFFA: 0.00,
                GRUPPO: 0,
                RICALCOLA_TERRENI: false
            };
            this.mostraFormTipo = true;
        },
        modificaTipoTerreno : function(tipo){
            this.tipoInModifica = utils.clone(tipo);
            this.tipoInModifica.RICALCOLA_TERRENI = false;
            this.mostraFormTipo = true;
        },
        applicaTariffaATutti : function(tipo){
            var tariffa = parseFloat(tipo.TARIFFA || 0).toFixed(2);
            var modoDesc = tipo.MODO === 'F' ? 'fissa' : 'proporzionale alla superficie';
            utils.alert.confirm("Vuoi applicare la tariffa di € " + tariffa + " (" + modoDesc + ") a tutti i terreni di tipo \"" + tipo.DESCRIZIONE + "\" ricalcolando Canone Unitario e Canone Totale?", () => {
                global.utils.post('/emmet/tipi_terreno/aggiorna_tariffe', { ID_TIPO: tipo.ID_TIPO, TARIFFA: tipo.TARIFFA }, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio || 'Tariffe terreni aggiornate');
                        this.getTerreni();
                        this.getTipiTerreno();
                    }
                });
            }, this.$root);
        },
        salvaTipoTerreno : function(){
            if (!this.tipoInModifica.DESCRIZIONE || this.tipoInModifica.DESCRIZIONE.trim() === ''){
                utils.alert.error('Inserire una descrizione per la tipologia');
                return;
            }
            var ricalcola = this.tipoInModifica.RICALCOLA_TERRENI;
            if (this.tipoInModifica.ID_TIPO > 0){
                global.utils.put('emmet/tipo_terreno', this.tipoInModifica, (response) => {
                    if (response.esito == 0){
                        if (ricalcola){
                            global.utils.post('/emmet/tipi_terreno/aggiorna_tariffe', { ID_TIPO: this.tipoInModifica.ID_TIPO, TARIFFA: this.tipoInModifica.TARIFFA }, (respR) => {
                                utils.alert.success((response.messaggio || 'Tipologia aggiornata') + ' - ' + (respR.messaggio || 'Terreni ricalcolati'));
                                this.mostraFormTipo = false;
                                this.getTipiTerreno();
                                this.getTerreni();
                            });
                        } else {
                            utils.alert.success(response.messaggio || 'Tipologia aggiornata');
                            this.mostraFormTipo = false;
                            this.getTipiTerreno();
                            this.getTerreni();
                        }
                    }
                });
            } else {
                global.utils.post('emmet/tipo_terreno', this.tipoInModifica, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio || 'Tipologia creata');
                        this.mostraFormTipo = false;
                        this.getTipiTerreno();
                        this.getTerreni();
                    }
                });
            }
        },
        eliminaTipoTerreno : function(tipo){
            utils.alert.confirm("Sei sicuro di voler eliminare la tipologia \"" + tipo.DESCRIZIONE + "\"?", () => {
                global.utils.delete('emmet/tipo_terreno', { ID_TIPO: tipo.ID_TIPO }, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio || 'Tipologia eliminata');
                        this.getTipiTerreno();
                        this.getTerreni();
                    }
                });
            }, this.$root);
        },
        getTerreno: function(idTerreno){
            global.utils.get('emmet/terreno',{ID_TERRENO: idTerreno},(response)=>{
                this.terrenoSelezionato = utils.clone(response.data);
                this.terrenoSelezionato.isAssegnato = false;
                if (response.data.assegnazioni != undefined){
                    response.data.assegnazioni.forEach(assegnazione => {
                        if (assegnazione.VALIDO == 1){
                            this.terrenoSelezionato.isAssegnato = true;
                        }
                    });
                }
            });
        },  
        modificaTerreno: function(idTerreno){
            var modal = utils.openModal('popUpTerreno');
            this.getTerreno(idTerreno);
        },
        salvaTerreno : function(){
            if (!this.terrenoSelezionato.FK_ID_TIPO){
                this.terrenoSelezionato.FK_ID_TIPO = 1;
            }
            //update
            if(this.terrenoSelezionato.ID_TERRENO > 0){
                global.utils.put('/emmet/terreno',this.terrenoSelezionato, (response) => {
                    if (response.esito == 0){
                        this.getTerreni();
                        var modal = utils.closeModal('popUpTerreno')
                        utils.alert.success(response.messaggio);
                    }
                });
            }else{
                global.utils.post('/emmet/terreno',this.terrenoSelezionato,(response)=>{
                    if (response.esito == 0){
                        this.getTerreni()
                        var modal = utils.closeModal('popUpTerreno')
                        utils.alert.success(response.messaggio);
                    }
                });
            }
        },
        creaTerreno : function(){
            this.terrenoSelezionato = {ID_TERRENO:0, FK_ID_TIPO: 1}
            var modal = utils.openModal('popUpTerreno'); 
        },
        
    },
    computed : {
        paginatedList(){
            var arr = utils.inGrid(this.arrayTerreni,this.search);
            return arr;
        },
        arrayTipiTerrenoPadri(){
            var curId = this.tipoInModifica ? this.tipoInModifica.ID_TIPO : 0;
            return this.arrayTipiTerreno.filter(t => t.ID_TIPO != curId && (!t.GRUPPO || t.GRUPPO == 0));
        }
    },
    created : function(){
       this.getTerreni(); 
       this.getTipiTerreno();
    },

}


</script>
